import { render, staticRenderFns } from "./FileDownloadIcon.vue?vue&type=template&id=00a33416&scoped=true&"
import script from "./FileDownloadIcon.vue?vue&type=script&lang=js&"
export * from "./FileDownloadIcon.vue?vue&type=script&lang=js&"
import style0 from "./FileDownloadIcon.vue?vue&type=style&index=0&id=00a33416&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a33416",
  null
  
)

export default component.exports